export default __webpack_public_path__ + "static/media/giveape.e5520744.gif";